module.exports = __webpack_public_path__ + "img/assistantAccount-home-warp3-img1.70f129a4.png";